var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5769 41.023L32 33.5999L39.423 41.023L41.023 39.423L33.5999 32L41.023 24.5769L39.423 22.9769L32 30.4L24.5769 22.9769L22.9769 24.5769L30.4 32L22.9769 39.423L24.5769 41.023ZM32.0033 50.9999C29.3959 50.9999 26.9393 50.5012 24.6335 49.5039C22.3276 48.5066 20.3111 47.1447 18.584 45.4184C16.8569 43.692 15.4944 41.6764 14.4967 39.3716C13.4989 37.0667 13 34.6106 13 32.0033C13 29.3754 13.4987 26.9054 14.496 24.5931C15.4933 22.2808 16.8552 20.2694 18.5815 18.559C20.3079 16.8485 22.3235 15.4944 24.6283 14.4967C26.9332 13.4989 29.3893 13 31.9966 13C34.6245 13 37.0945 13.4987 39.4068 14.496C41.7191 15.4933 43.7305 16.8468 45.4409 18.5565C47.1514 20.2662 48.5055 22.2767 49.5033 24.588C50.501 26.8992 50.9999 29.3687 50.9999 31.9966C50.9999 34.604 50.5012 37.0606 49.5039 39.3665C48.5066 41.6723 47.1531 43.6888 45.4434 45.4159C43.7337 47.143 41.7232 48.5055 39.412 49.5033C37.1007 50.501 34.6312 50.9999 32.0033 50.9999ZM32 48.7307C36.6564 48.7307 40.6089 47.1012 43.8577 43.8423C47.1064 40.5833 48.7307 36.6359 48.7307 32C48.7307 27.3436 47.1064 23.391 43.8577 20.1423C40.6089 16.8936 36.6564 15.2692 32 15.2692C27.3641 15.2692 23.4166 16.8936 20.1577 20.1423C16.8987 23.391 15.2692 27.3436 15.2692 32C15.2692 36.6359 16.8987 40.5833 20.1577 43.8423C23.4166 47.1012 27.3641 48.7307 32 48.7307Z",
    fill: "#D92D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidCircle);
export default __webpack_public_path__ + "static/media/invalidCircle.1c86697c17afb56a490345ff464d18b8.svg";
export { ForwardRef as ReactComponent };